var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('popper',{attrs:{"trigger":"clickToOpen","options":{
      placement: this.placement,
      modifiers: { offset: { offset: '0,10px' } }
    }},on:{"created":_vm.onPopperCreated}},[_c('div',{staticClass:"popper",class:{ 'mobileshare': _vm.mobile === true }},[_c('div',{staticClass:"sharethis-inline-share-buttons"})]),_vm._v(" "),_c('a',{attrs:{"slot":"reference"},slot:"reference"},[_c('i',{staticClass:"fi flaticon-multimedia"})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }